import safeGetPathname from './safeGetPathname';
import { PRODUCTS } from '../consts';

export default (currentAccount) => {
  const pathname = window.location.pathname;
  const currentService = currentAccount.services.find((s) =>
    pathname.startsWith(safeGetPathname(s.account_url))
  );
  if (!currentService) {
    return undefined;
  }
  const currentProduct = PRODUCTS.find(
    (p) => p.serviceType === currentService.service_type
  );
  return currentProduct?.id;
};
